// extracted by mini-css-extract-plugin
export default {"item":"attachmentItem_item__qMQps","grid":"attachmentItem_grid__0J8p7"};